import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray, lightergray } from '../../styles/colors'

export const Title = styled.div`
  margin-bottom: 1.5rem;
  font-size: 18px;
  font-weight: 500;

  ${maxmedia.medium`
    padding: 0 1rem;
  `}

  div {
    font-weight: 300;
    display: block;
    margin-top: .25rem;

    &:first-letter {
      text-transform: uppercase;
    }

    ${minmedia.medium`
      display: inline-block;
      margin-left: 1rem;
      margin-top: 0;
    `}
  }

  ${minmedia.medium`
    font-size: 18px;
    margin-bottom: 2rem;
  `}
  ${minmedia.large`
    font-size: 24px;
    text-align: center;
  `}
`

export const Box = styled.div`
  max-width: 100%;
  width: 1080px;
  margin: 0 auto;
  border-top: 1px solid ${bordergray};

  ${minmedia.medium`
    border: 1px solid ${bordergray};
    border-bottom: 0;
  `}
`

export const Content = styled.div``

export const Header = styled.div`
  background: ${lightergray};
  padding: 1rem;
  font-weight: 500;
  font-size: 18px;

  ${minmedia.medium`
    padding: 1rem 1.5rem;
  `}
  ${minmedia.large`
    padding: 1rem 2rem;
    font-size: 20px;
  `}
`



// WEBPACK FOOTER //
// ./src/components/Appointments/styles.js